/*
 * NOTE: This component is a port of backbone code
 * It should be cleaned and simplifed in stage 2 of raven project
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import classNames from 'classnames';

import ScribeLink from 'apps/scribe/ScribeLink';

export default class NavigationMenuContent extends PureComponent {
  static propTypes = {
    closeMobileNav: PropTypes.func.isRequired,
    ignoreChildren: PropTypes.bool,
    logout: PropTypes.func.isRequired,
    sections: PropTypes.arrayOf(PropTypes.shape({
      sectionId: PropTypes.string,
      sectionHeader: PropTypes.string,
      children: PropTypes.array,
    })).isRequired,
    setMobileNavLevel: PropTypes.func.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
  };

  onLogoutClick = (event) => {
    event.preventDefault();
    this.props.logout().then(() => {
      this.props.closeMobileNav();
    });
  };

  onParentClick = (event, childrenId) => {
    event.preventDefault();
    this.props.setMobileNavLevel(childrenId);
  };

  onLinkClick = () => {
    this.props.closeMobileNav();
  };

  getItemNode(item) {
    const { ignoreChildren } = this.props;
    if (item.id === 'logout') {
      return (
        <button
          className="button-link"
          onClick={this.onLogoutClick}
        >
          {item.name}
        </button>
      );
    } else if (item.childrenId && !ignoreChildren) {
      return (
        <button
          className="button-link"
          onClick={(e) => this.onParentClick(e, item.childrenId)}
        >
          {item.name}
        </button>
      );
    } else if (item.id) {
      return <ScribeLink className="section-link" to={item.url} onClick={this.onLinkClick}>{item.name}</ScribeLink>;
    }

    return item.url.includes('https://') ?
      <a className="section-link" href={item.url}>{item.name}</a> : // Needed to redirect to an external url.
      <Link className="section-link" to={item.url} onClick={this.onLinkClick}>{item.name}</Link>;
  }

  render() {
    const { sections, isLoggedIn } = this.props;
    const sectionsNodes = sections.map((sect, key) => {
      if (!isLoggedIn && sect.sectionId === 'SectionAccount') {
        return null;
      }

      const sectItems = sect.children || [];
      const outKey = `${sect.sectionId}${key}`;
      return (
        <li
          key={outKey}
          className="section"
        >
          {sect.sectionHeader ?
            <div className="section-title">{sect.sectionHeader}</div> :
            null
          }
          <ul className="section-items">
            {sectItems.map((sectItem, itemKey) => {
              const inKey = `${sectItem.name}${itemKey}`;
              return (
                <li
                  key={inKey}
                  className={classNames('section-item', { 'show-for-xlarge': sectItem.desktopOnly })}
                >
                  {this.getItemNode(sectItem)}
                </li>
              );
            })}
          </ul>
        </li>
      );
    });

    return (
      <div className="navigation-content">
        <ul>
          {sectionsNodes}
        </ul>
      </div>
    );
  }
}
